// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'tiny... Remove this comment to see the full error message
import tinymce from 'tinymce';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'tiny... Remove this comment to see the full error message
import { knowledgeBaseSchema } from 'tinymce-config/schemas/knowledge-base';
export default function convertArticleBodyToTinymce(articleHtml) {
  const schema = new tinymce.html.Schema();
  schema.addValidChildren(knowledgeBaseSchema);
  const parser = new tinymce.html.DomParser(schema);
  const serializer = new tinymce.html.Serializer();
  const sanitizedHtml = serializer.serialize(parser.parse(articleHtml));
  return sanitizedHtml;
}